import { Box } from "@mui/material";
import * as React from "react";
import PropTypes from "prop-types";
import version from "../../version.json";

const Footer = ({ width = "none" }) => {
  return (
    <Box className="area-footer" width={width} sx={{ borderTop: "1px solid #C4C4C4" }}>
      {/* &copy; 2024 -TOYOTA MOTOR ASIA (THAILAND) CO., LTD. All Rights Reserved */}
      {/* Polygon &copy; 2024 version {process.env.REACT_APP_VERSION} */}
      Polygon &copy; 2024 version <b>{version.packageVersion}</b>{" "}
      {process.env.REACT_APP_ENV_NAME !== "master" && <b>({process.env.REACT_APP_ENV_NAME})</b>} <br />
    </Box>
  );
};

Footer.propTypes = { width: PropTypes.string };

export default Footer;
